import { memo } from 'react'
const BidStatusTooltip = ({ campaign, inventoryCampaign, publisher, clusterLevel, language, renderStatusStr, render_status_labels, taxonomy }) => {
    const status = renderStatusStr(
        campaign?.ppc_active,
        inventoryCampaign?.inventory_campaign_status,
        inventoryCampaign?.ppc_bid_active,
        campaign?.ppc_paused,
        inventoryCampaign?.inherited_cpc,
        publisher?.cluster_inherited_bid_mode_enabled,
        clusterLevel,
        inventoryCampaign?.cluster_status,
        language
    )

    const labels = render_status_labels[language]
    const tooltips = taxonomy.tooltips.ppc_managment_modal.bid_status

    const statusMap = {
        Paused: tooltips.paused,
        Live: tooltips.live,
        Pending: tooltips.pending,
        Inactive: tooltips.inactive
    }

    for (const [key, tooltip] of Object.entries(statusMap)) {
        if (status.includes(labels[key])) {
            return tooltip
        }
    }

    return null
}

export default memo(BidStatusTooltip)
